import Loading from "../../../../shared/Loading/Loading";
import ResetPassword from "../../hooks/ResetPassword/ResetPassword";
import Form from "./Form";
import InvalidSession from "./InvalidSession";

const ResetPasswordForm = ({ onBackToLogin, logout, code, message}) => {
  const vm = ResetPassword({onBackToLogin, code, logout, message})

  return vm.loading || vm.redirecting ? (
    <div className="flex items-center justify-center min-h-[220px]">
      <Loading size="28" colorBase="font" colorAccent="white" double={true} bold="8" />
    </div>
  ) : (
    <div className="p-8 bg-white shadow-md rounded-lg max-w-md mx-auto">
      {vm.active ? (
        <>
          <h2 className="text-2xl text-center mb-6">Restablecer contraseña</h2>
          {!code && (
            <p className="text-sm text-red-600 mb-3">Enlace inválido o expirado.</p>
          )}
          <Form
            canSubmit={vm.canSubmit}
            submit={vm.submit}
            loading={vm.loading}
            password={vm.password}
            confirm={vm.confirm}
            setPassword={vm.setPassword}
            setConfirm={vm.setConfirm}
          />
        </>
      ) : (
        <InvalidSession returnPage={vm.returnPage} />
      )}
    </div>
  );
};

export default ResetPasswordForm;
